import React, { useCallback, useEffect } from 'react';

import Message from '../../atoms/Message';
import { useMessages } from '../../../hooks/Messages';

function Communication({ scrollToBottom }: any) {
    const { messages } = useMessages();

    const scrollToBottomDellayed = useCallback(
        () => scrollToBottom(100),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    useEffect(
        () => {
            scrollToBottom();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [messages]
    );

    return (
        <div id='stx-chat'>
            {
                messages.map((message) => (
                    <Message
                        key={message.id}
                        {...message}
                        scrollToBottom={scrollToBottomDellayed} />
                ))
            }
        </div>
    );
}

export default Communication;
